import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

import MainButton from "../../common/MainButton";
import StudentListTable from "./StudentsList";
import MainTitle from "../../common/MainTitle";

import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";

import * as XLSX from "xlsx-js-style";

const FinanceStudentsList = (props) => {
  const [data, setData] = useState([]);
  const { halfYear } = useContext(HalfYearContext);

  const { fid, cid } = props.match.params;

  useEffect(async () => {
    const ac = new AbortController();
    requestData({ halfYear });
    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `students/fees/faculties/${fid}/classes/${cid}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const handleExportToExcel = () => {
    const students = data?.data || [];
    const summary = data?.summary || {};
    const title = summary.title || lbl.StudentsFees;

    const headerStyle = {
      font: { bold: true, sz: 11 },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      fill: { fgColor: { rgb: "FFE8EEF5" } },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center" },
    };

    const titleStyle = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const totalStyle = {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "center" },
      fill: { fgColor: { rgb: "FFF2F2F2" } },
    };

    const headers = [
      "شماره",
      "کد دانشجو",
      "اسم",
      "ولد",
      "فیس",
      "تخفیف",
      "پرداخت شده",
      "باقی‌مانده",
      "مجموعه باقی",
    ];

    const rows = students.map((s, index) => [
      index + 1,
      s.aria_id ?? "",
      s.full_name ?? "",
      s.student_father_name ?? "",
      toNumber(s.fee),
      toNumber(s.discount),
      toNumber(s.paid),
      toNumber(s.payable),
      toNumber(s.current_overall_balance),
    ]);

    const feeTotal = students.reduce((sum, s) => sum + toNumber(s.fee), 0);
    const totalsRow = [
      "مجموعه",
      "",
      "",
      "",
      feeTotal,
      toNumber(summary.discount),
      toNumber(summary.paid),
      toNumber(summary.payable),
      toNumber(summary.current_overall_balance),
    ];

    const sheetData = [[title], [], headers, ...rows, totalsRow];
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    worksheet["!views"] = [{ rightToLeft: true, state: "normal" }];
    worksheet["!cols"] = [
      { wch: 8 },
      { wch: 14 },
      { wch: 22 },
      { wch: 16 },
      { wch: 12 },
      { wch: 12 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
    ];
    worksheet["!rows"] = [{ hpt: 28 }, { hpt: 10 }, { hpt: 22 }];

    const applyStyle = (cellAddress, style) => {
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        ...(worksheet[cellAddress].s || {}),
        ...style,
      };
    };

    applyStyle("A1", titleStyle);

    headers.forEach((_, col) => {
      applyStyle(XLSX.utils.encode_cell({ r: 2, c: col }), headerStyle);
    });

    const moneyCols = [4, 5, 6, 7, 8];
    rows.forEach((_, rowIndex) => {
      const r = rowIndex + 3;
      headers.forEach((__, col) => {
        const addr = XLSX.utils.encode_cell({ r, c: col });
        applyStyle(addr, cellStyle);
        if (moneyCols.includes(col) && worksheet[addr]) {
          worksheet[addr].t = "n";
          worksheet[addr].z = "#,##0.00";
        }
      });
    });

    const totalRowIndex = rows.length + 3;
    headers.forEach((_, col) => {
      const addr = XLSX.utils.encode_cell({ r: totalRowIndex, c: col });
      applyStyle(addr, totalStyle);
      if (moneyCols.includes(col) && worksheet[addr]) {
        worksheet[addr].t = "n";
        worksheet[addr].z = "#,##0.00";
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Student Fees");

    const safeTitle = String(title)
      .replace(/[\\/:*?"<>|]/g, "-")
      .replace(/\s+/g, "_")
      .slice(0, 80);

    XLSX.writeFile(workbook, `student_fees_class_${cid}_${safeTitle || "export"}.xlsx`, {
      bookType: "xlsx",
      compression: true,
      cellStyles: true,
    });
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center"></div>
        <div className="left-content">
          <MainPrintLink path={`student/fees/faculty/${fid}/class/${cid}`} />
          <MainButton title={lbl.Excel} type={"excel"} handleClick={handleExportToExcel} />
        </div>
      </div>
      <div className="main-content-body">
        <StudentListTable data={data} />
      </div>
    </div>
  );
};

export default FinanceStudentsList;
